import React, { createContext, useContext } from 'react'

import type { ItemState } from '~/utils/slices/@types/ItemState'

import type { Session } from './@types'
import useCreateSession from './hooks/useCreateSession'
import useSessionLocalStorage from './hooks/useSessionLocalStorage'

type ContextState = ItemState<Session> & {
  auth: (appId: string) => void
}

const ContextState = createContext<ContextState | undefined>(undefined)

function AuthProvider({ children }: React.PropsWithChildren) {
  const [data] = useSessionLocalStorage()
  const { isPending: loading, mutate: auth, error } = useCreateSession()

  const state = data
    ? {
        loaded: true as const,
        loading,
        data,
        auth,
      }
    : {
        loaded: false as const,
        loading,
        error: error || undefined,
        auth,
      }

  return <ContextState.Provider value={state}>{children}</ContextState.Provider>
}

export const useAuth = () => {
  const context = useContext(ContextState)
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider')
  }
  return context
}

export default AuthProvider
